export default "__VITE_ASSET__DGKG2uXq__"